import React, { useState } from "react";
import DepartMentList from "./Department/mainDepartment";
import TargetList from "./Targetssalary/mainTargets";
import { ROLE } from "../../../../../utils/Constant";
import EmpList from "./Employee/mainEmp";
import AllAttendence from "./Employee/allempattendence";
const MainEmp = ({ admin }) => {
    const [viewType, setviewType] = useState('emp')
    const [editData, seteditData] = useState('')

    const editHandler = (data) => {
        console.log(data)
        if (data.id) {
            seteditData(data)
            setviewType('add')
        }



    }
    const ChangeScreen = (type) => {
        seteditData('')
        setviewType(type)
    }
    return (
        <div className="container-fluid">
            {/* <div style={{ display: 'flex', textAlign: 'center' }}>
                <div onClick={() => ChangeScreen('list')} style={{ color: viewType === 'list' ? '#fff' : '#000', background: viewType === 'list' ? '#337ab7' : '#f4f3f1', padding: '10px', borderRadius: '5px', width: '40px', height: '40px', cursor: 'pointer' }}> <i className="fa fa-list" ></i></div>&nbsp;&nbsp;

            </div> */}
            <div className="row fixed-top" style={{ marginTop: '76px', display: 'flex', width: '100%' ,zIndex:'10' }}>

                <div className={`expenseListTab ${viewType == "emp" ? "active" : ""}`} onClick={() => setviewType('emp')} style={{  textAlign:'center',background: '#DBE9FF', width: '25%',borderRadius:'0' }}>
                    Employees

                </div>
                {
                    admin.rolelist.indexOf(ROLE.VIEW_EMPLOYEE_ATTENDENCE) >= 0 && (
                        <div className={`expenseListTab ${viewType == "attendence" ? "active" : ""}`} onClick={() => setviewType('attendence')} style={{  textAlign:'center',background: '#DBE9FF', width: '25%',borderRadius:'0' }}>
                    All Employee Attendance

                </div>
                )}
                <div className={`expenseListTab ${viewType == "department" ? "active" : ""}`} onClick={() => setviewType('department')} style={{  textAlign:'center',background: '#DBE9FF', width: '25%',borderRadius:'0' }}>
                    Departments

                </div>
                <div className={`expenseListTab ${viewType == "target" ? "active" : ""}`} onClick={() => setviewType('target')} style={{  textAlign:'center',background: '#DBE9FF', width: '25%',borderRadius:'0' }}>
                    Targets

                </div>

            </div>
            <div style={{ marginTop: '50px' }}>
                {viewType === 'emp' ?
                    <EmpList showButton={false} admin={admin} editHandler={editHandler} />
                    : ""}
                {viewType === 'department' ?
                    <DepartMentList showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'target' ?
                    <TargetList showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'attendence' ?
                    <AllAttendence showButton={false} admin={admin} editData={editData} />
                    : ""}
            </div>

        </div>
    )
}
export default MainEmp